import React, { useState } from 'react'
import { useIntl } from 'react-intl'

import UserCanAskQuotationModal from '../user-can-ask-quotation-modal/UserCanAskQuotationModal'
import { errorToast } from '../../../../../../../utils'
import {
  EnvironmentTypeEnum,
  useEnvironmentTypeContext,
} from '../../../../../../contexts'
import { IProposalInteractionsProps } from '../../../../Proposal'
import PingPongButton from '../../../buttons-by-step/PingPongButton'
import { PingPongButtonTypeEnum } from '../../../utils/ping-pong-button-type.enum.ts'

const UserCanAskQuotationFooter = ({
  clientProposalId,
  userActions,
  phoneNumber,
}: {
  clientProposalId: string
  userActions: IProposalInteractionsProps['userActions']
  phoneNumber: string
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const intl = useIntl()
  const environement = useEnvironmentTypeContext()
  const isApp = environement === EnvironmentTypeEnum.APP

  const userAskedQuotation = userActions?.userAskedQuotation

  if (!userAskedQuotation) {
    return null
  }

  const handleClickAskQuotation = () => {
    isApp ? setIsOpen(true) : userAskedQuotation.callback({ clientProposalId })
  }

  const onSubmit = async ({ phoneNumber }: { phoneNumber?: string }) => {
    try {
      await userAskedQuotation.callback({ clientProposalId, phoneNumber })
      setIsOpen(false)
    } catch {
      errorToast([
        intl.formatMessage({
          id: 'ui.UserCanAskQuotationFooter.error',
          defaultMessage: 'Impossible de faire la demande de devis',
        }),
      ])
    }
  }

  return (
    <>
      <PingPongButton
        dataTestId='user-ask-quotation-button'
        label={intl.formatMessage({
          id: 'ui.UserAskedQuotationButton.userAskedQuotation',
          defaultMessage: 'Demander un devis',
        })}
        type={PingPongButtonTypeEnum.CONFIRM}
        onClick={handleClickAskQuotation}
        // On the app only we open a modal to ask the user for his phone number
        {...(!isApp && { isLoading: userAskedQuotation.isLoading })}
      />

      {isOpen && isApp && (
        <UserCanAskQuotationModal
          closeModal={() => setIsOpen(false)}
          onSubmit={onSubmit}
          isOpen={isOpen}
          phoneNumber={phoneNumber}
          isLoading={userAskedQuotation.isLoading}
        />
      )}
    </>
  )
}

export default UserCanAskQuotationFooter
